import keyMirror from 'keymirror';

const CONSTANTS = {
  ActionTypes: keyMirror({
    HOTEL_LOAD: null,
    CATEGORY_ADD: null,
    HOTEL_LIST_LOAD: null,
    CATEGORY_DELETE: null,
    AUTH: null,
    CTOOL: null,
    LOGOUT: null,
    NAVIGATE: null,
    NODE_CLEAR: null,
    NODE_LOAD: null,
    NODE_DESIGN: null,
    MAP_SET_MARKERS: null,
    MAP_SET_CMARKERS: null,
    MAP_PUSH_CMARKER: null,
    MAP_SET_POLYLINES: null,
    MAP_SET_CENTER: null,
    MAP_SET_CURSOR: null,
    MAP_SET_CLICK_LISTENER: null,
    MAP_SET_POI_CLICK_LISTENER: null,
    POI_DETAILS_LOAD: null,
    HANDLE_DELETE_DIALOG: null,
    HANDLE_SETSTART_DIALOG: null,
    HANDLE_GUIDE_SNACKBAR: null,
    HANDLE_GUIDE_DIALOG: null,
    SET_USER_HOTEL: null,
    GMAP2_INIT: null,
    GMAP2_DESTROY: null,
    DEST_PROFILE_LOAD: null,
    DEST_NODES_LOAD: null,
    POI_AREA_SHAPE_CHANGE: null,
    POI_LOCATION_CHANGE: null,
    SET_USER_LANGUAGE: null,
    ADD_PARTNERID: null,
    ACCEPT_CONTRACT: null,
    INITIAL_PASSED: null,
    INTRO_PASSED: null,
    FILL_PROFILE: null,
    NEED_TO_PAY: null,
    ALLOWPARTNERSIDS: null,
    DIC_NODES_LOAD: null,
    HLP_NODES_LOAD: null,
    PARTNERS_LOAD: null,
    PARTNER_LOAD: null,
    SALES_POINTS_LOAD: null,
    SALES_POINT_LOAD: null,
    SALES_POINT_POI_CHANGE: null,
    DIC_OPEN_CLOSE_NODE: null,
    DIC_SET_FOR_SCROLL: null,
    HLP_OPEN_CLOSE_NODE: null,
    HLP_SET_FOR_SCROLL: null,
    DEST_OPEN_CLOSE_NODE: null,
    DEST_SET_FOR_SCROLL: null,
    HOTEL_OPEN_CLOSE_NODE: null,
    HOTEL_SET_FOR_SCROLL: null,
    COMMISIONS_LOAD: null,
    COMMISION_MONTHS_LOAD: null,
    DEST_LIST_LOAD: null,
    USERS_LOAD: null,
    USER_LOAD: null,
    COUNTRIES_LOAD: null,
    RQDATA: null,
    HOTEL_ID_SET: null,
  }),
  StoreKey: keyMirror({
    NAVIGATION_CURRENT: null,
    NODE: null,
    MAP_MARKERS: null,
    MAP_CMARKERS: null,
    MAP_POLYLINES: null,
    MAP_CENTER: null,
    MAP_CURSOR: null,
    MAP_CLICK_LISTENER: null,
    POI_DETAILS: null,
    DELETE_DIALOG: null,
    SETSTART_DIALOG: null,
    GUIDE_SNACKBAR: null,
    GUIDE_DIALOG: null,
    PARTNER: null,
    SALES_POINT: null,
    USER: null,
  }),
};

export default CONSTANTS;
export const { ActionTypes } = CONSTANTS;
export const { ServerConfig } = CONSTANTS;
export const { StoreKey } = CONSTANTS;
